
const state = {
  id: null,
  campaign_id: undefined,
  campaign_quote_id: undefined,
  custom_item_id: undefined,
  data: {},
  invoice_date: '',
  invoice_notes: '',
  invoice_reference: '',
  invoice_total: undefined,
  item_type: 'custom',
  paid_by: '',
  price: 0,
  price_override: 0,
  tax_rate: 10,
  title: '',
  user_id: undefined,
}

export const requiredFields = [
  { key: 'title' },
]

export default state
